import { createActions } from 'reduxsauce';

var _createActions = createActions({
  receiveError: function receiveError(err) {
    return {
      type: 'RECEIVE_ERROR',
      err: err,
      receivedAt: Date.now()
    };
  },
  resetError: function resetError(err) {
    return {
      type: 'RESET_ERROR',
      err: null,
      isError: false,
      receivedAt: null
    };
  }
}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};